import { DeletePriceBody, Price, topliApi } from '@/shared/api/topli/TopliApi'
import { EditPriceFormState } from '../model/types'
import { hasPriceChanged } from '@/shared/helpers/priceHelpers'

export const updatePrices = async (
  prices: EditPriceFormState[],
  originalPrices: EditPriceFormState[],
) => {
  const oldPrices = prices.filter(price => price.id)
  const newPrices = prices.filter(price => !price.id && price.price > 0)

  let responseNewPrices
  let responseOldPrices

  const changedOldPrices = oldPrices.filter(price => {
    const originalPrice = originalPrices.find(orig => orig.id === price.id)
    return originalPrice && hasPriceChanged([price], [originalPrice])
  })

  if (changedOldPrices.length > 0) {
    responseOldPrices = await topliApi.prices.update({
      prices: changedOldPrices as Price[],
    })
  }

  if (newPrices.length > 0) {
    responseNewPrices = await topliApi.prices.addPrices({
      prices: newPrices as Price[],
    })
  }

  return { responseOldPrices, responseNewPrices }
}

export const deletePrice = async (data: DeletePriceBody) => {
  const response = await topliApi.prices.delete(data)
  return response
}
